import React, { useRef, useState } from "react";
import { useGetSkuGuidelines } from "../../hooks/useGuidelines";
import { useSearchParams } from "react-router-dom";
import actionBtn from "../../assets/CreateSet/actionBtn.svg";
import "./style.scss";
import { Select } from "antd";

const AdaptationView = () => {
  const [adaptationViewData, setAdaptationViewData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState();
  const [activeTab, setActiveTab] = useState("");
  const headingWrapperRef = useRef(null);
  const listScrollableWrapperRefs = useRef([]);

  const handleScroll = (e) => {
    const { scrollTop } = e.target;
    if (e.target === headingWrapperRef.current) {
      listScrollableWrapperRefs.current.forEach((ref) => {
        if (ref) ref.scrollTop = scrollTop;
      });
    } else {
      headingWrapperRef.current.scrollTop = scrollTop;
      listScrollableWrapperRefs.current.forEach((ref) => {
        if (ref !== e.target) {
          ref.scrollTop = scrollTop;
        }
      });
    }
  };

  const [searchParams] = useSearchParams();

  const skuId = searchParams.get("skuId");

  const onSuccessGetAllViewData = (res) => {
    if (res.status === 200) {
      setAdaptationViewData(res?.data?.data);
      setTotalCount(res.data.totalCount);
      if (res?.data?.data && Object.keys(res?.data?.data).length > 0) {
        setActiveTab(Object.keys(res?.data?.data)[0]);
      }
    }
  };
  const onErrorGetAllViewData = (err) => {
    console.log(err);
  };
  const { data: getAllViewData } = useGetSkuGuidelines(
    "getAllViewData",
    skuId,
    pageNum,
    pageSize,
    onSuccessGetAllViewData,
    onErrorGetAllViewData
  );

  const handleActive = (tab) => {
    setActiveTab(tab);
  };

  const filteredData = adaptationViewData[activeTab] || [];

  return (
    <div className="adaptation_view">
      <div className="tab_section">
        {Object?.keys(adaptationViewData)?.map((key) => {
          return (
            <button
              key={key}
              className={`tab ${activeTab === key ? "active" : ""}`}
              onClick={(e) => handleActive(key)}
            >
              {key}
            </button>
          );
        })}
      </div>
      <div className="content_section">
        <div className="sequential_detail_wrapper">
          <div className="sequential_content">
            <div className="heading_section">
              <div className="empty_container"></div>
              <div className="heading" style={{ height: "60px" }}>
                Sequence No.
              </div>
              <div
                className="heading_wrapper"
                ref={headingWrapperRef}
                onScroll={handleScroll}
              >
                <div
                  className="heading"
                  style={{ height: "calc(100% - 105px)" }}
                >
                  Shoot Type
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% - 101px)" }}
                >
                  Angle Name
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% - 101px)" }}
                >
                  Dimension (in pixels)(W*H)
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% - 100px)" }}
                >
                  {" "}
                  DPI
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% - 101px)" }}
                >
                  Alignment
                </div>
                <div className="heading" style={{ height: "calc(100%)" }}>
                  Margin (in pixels)
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% - 101px)" }}
                >
                  Color Mode
                </div>
                <div className="heading" style={{ height: "calc(100%)" }}>
                  Background
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% - 101px)" }}
                >
                  {" "}
                  Shadow
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% + 27px)" }}
                >
                  Crop Type
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% - 100px)" }}
                >
                  File Formats
                </div>
                <div
                  className="heading"
                  style={{ height: "calc(100% - 98px)" }}
                >
                  Max file size (in MB)
                </div>
                {/* <div className="heading" style={{ marginBottom: "0px" }}>
              is Active
            </div> */}
              </div>
            </div>
            <div className="list_section">
              {filteredData?.map((list, index) => {
                return (
                  <div
                    className="list_item_wrapper"
                    key={`${list.angleGlobal} ${index}`}
                  >
                    <div className="empty_container">
                      <img
                        src={list?.image?.thumbPath?.url}
                        alt={list?.image?.name}
                      />
                    </div>
                    <div className="sequence_number">{index + 1}</div>
                    <div
                      className="list_scrollable_wrapper"
                      ref={(el) =>
                        (listScrollableWrapperRefs.current[index] = el)
                      }
                      onScroll={handleScroll}
                      key={list.angleGlobal}
                    >
                      <div className="shootType">{list?.shootType}</div>
                      <div className="angleName">{list?.name}</div>
                      {/* <button
                            className="changeBtn"
                            onClick={() => handleChangeAngle(list?.angleGlobal)}
                          >
                            Change
                          </button> */}
                      <div className="dimension_wrapper">
                        <div className="width_wrapper">
                          {list?.dimensions?.width}
                        </div>
                        {""}
                        <div className="cross_icon_wrapper">x</div>
                        <div className="height_wrapper">
                          {list?.dimensions?.height}
                        </div>
                      </div>
                      <div className="dpi_input_wrapper">
                        <div className="dpi_input">{list?.dpi}</div>
                      </div>
                      <div className="alignment_wrapper">
                        <div>{list?.alignment}</div>
                      </div>
                      <div className="margin_wrapper">
                        <div className="col_one">
                          <div className="left_margin">
                            {list?.margins?.left}
                          </div>
                        </div>
                        <div className="col_two">
                          <div className="top_margin">{list?.margins?.top}</div>
                          <div className="buttons_wrapper">
                            <div className="left_btn_wrapper">
                              <img src={actionBtn} alt="actionBtn" />
                            </div>
                            <div className="center_btn_wrapper">
                              <div className="top_btn_wrapper">
                                <img src={actionBtn} alt="actionBtn" />
                              </div>
                              <div className="empty_wrapper" />
                              <div className="bottom_btn_wrapper">
                                <img src={actionBtn} alt="actionBtn" />
                              </div>
                            </div>
                            <div className="right_btn_wrapper">
                              <img src={actionBtn} alt="actionBtn" />
                            </div>
                          </div>
                          <div className="bottom_margin">
                            {list?.margins?.bottom}
                          </div>
                        </div>
                        <div className="col_three">
                          <div className="right_margin">
                            {list?.margins?.right}
                          </div>
                        </div>
                      </div>
                      <div className="color_mode_wrapper">
                        <div>{list?.colorMode}</div>
                      </div>
                      <div className="background_wrapper">
                        <div>{list?.backgroundColorType}</div>

                        <div className="input_wrapper">
                          {
                            // Object.keys(list.adaptation.background).find((key) =>
                            //   Array.isArray(list.adaptation.background[key])
                            //     ? list.adaptation.background[key].length > 0
                            //     : list.adaptation.background[key]
                            // )
                            list?.backgroundColorType === "hex" && (
                              <input
                                className="backgroundInput"
                                value={
                                  list?.background?.hex?.startsWith("#")
                                    ? list?.background?.hex
                                    : "#" + list?.background?.hex
                                }
                              />
                            )
                          }

                          {(list?.backgroundColorType === "rgb" ||
                            list?.backgroundColorType === "cmyk") && (
                            <>
                              <input
                                className="backgroundInput"
                                value={
                                  list?.background[
                                    list?.backgroundColorType
                                  ]?.[0] || ""
                                }
                              />

                              <input
                                className="backgroundInput"
                                value={
                                  list?.background[
                                    list?.backgroundColorType
                                  ]?.[1] || ""
                                }
                              />

                              <input
                                className="backgroundInput"
                                value={
                                  list?.background[
                                    list?.backgroundColorType
                                  ]?.[2] || ""
                                }
                              />

                              {list?.backgroundColorType === "cmyk" && (
                                <input
                                  className="backgroundInput"
                                  value={
                                    list?.background[
                                      list?.backgroundColorType
                                    ]?.[3] || ""
                                  }
                                />
                              )}
                            </>
                          )}

                          {
                            // Object.keys(list.adaptation.background)[0]
                            list?.backgroundColorType === "pantone" && (
                              <input
                                className="backgroundInput"
                                value={list?.background?.pantone || ""}
                              />
                            )
                          }
                        </div>
                      </div>

                      <div className="shadow_wrapper">
                        <div>{list.shadow}</div>
                      </div>
                      <div className="crop_type_wrapper">
                        <div>
                          <label>Name:</label>
                          {list?.cropType?.name}
                        </div>
                        <div>
                          <label>From:</label>
                          {list?.cropType?.from}
                        </div>

                        <div>
                          <label>To:</label>
                          {list?.cropType?.to}
                        </div>
                      </div>
                      <div className="file_formats_wrapper">
                        {list?.fileFormat}
                      </div>
                      <div className="file_size_wrapper">
                        <input
                          className="file_size_input"
                          value={list.maxFileSize}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdaptationView;
